module.exports = {"data":{"site":{"siteMetadata":{"domain":"www.fileforein.com","supportEmail":"support@FileForEIN.com"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/contact.json
// module id = 711
// module chunks = 184662623972074